import React from 'react';
import t from 'babel-plugin-yate/macro';
import {Block} from '../components/uiElem';
import {Products} from '../online/Products';
import {useSelector} from 'react-redux';

export default function ProductsList({data}) {
  const {productCategories} = useSelector(({request}) => request);

  return (
    <Block
      heading={t`Order summary`}
      description={t`Shopping cart`}
      descriptionClassName="saturn"
      className="bg-purple-lightest text-pink">
      <div className="px-4 pb-5 pt-8">
        <Products
          products={data?.products ?? []}
          total={data?.requested_amount ?? 0}
          productCategories={productCategories}
        />
      </div>
    </Block>
  );
}
